function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import dragAndDrop from './drag-and-drop';
import externalDragDefaultPreventer from './external-drag-default-preventer';
import { classNamesFor } from '../utils/classNames';
var cx;
/**
 * The FileDropArea component allows any UI to become a drop target for a file.
 *
 * ## Related Components
 * - [FileInput](../FileInput/README.md)
 *
 * ## Usage
 *
 * ```jsx
 * <FileDropArea
 *   label="Drop an image here!"
 *   accept="jpg,jpeg,png,webp"
 *   onFileDrop={(file) => console.log('dropped', file.name)}
 * >
 *    ... Any UI here
 * </FileDropArea>
 * ```
 *
 * ## Props
 */

var FileDropArea = /*#__PURE__*/function (_PureComponent) {
  _inherits(FileDropArea, _PureComponent);

  var _super = _createSuper(FileDropArea);

  function FileDropArea() {
    var _this;

    _classCallCheck(this, FileDropArea);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      shouldShowDropArea: false
    });

    _defineProperty(_assertThisInitialized(_this), "hideDropArea", function () {
      return _this.setState({
        shouldShowDropArea: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleDragLeave", function (event) {
      if (dragAndDrop.isDraggedOutsideWindow(event)) {
        _this.hideDropArea();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "showDropArea", function (event) {
      var disabled = _this.props.disabled;

      if (!disabled && dragAndDrop.isFileSystemDrag(event)) {
        _this.setState({
          shouldShowDropArea: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDragOver", function (event) {
      var disabled = _this.props.disabled;
      if (disabled) return;
      event.preventDefault();
      event.stopPropagation();
      dragAndDrop.styleCursor(event);
    });

    _defineProperty(_assertThisInitialized(_this), "onDrop", function (event) {
      var _this$props = _this.props,
          onFileDrop = _this$props.onFileDrop,
          disabled = _this$props.disabled;
      if (disabled) return;
      var droppedFiles = event.dataTransfer && event.dataTransfer.files || [];
      var firstFile = droppedFiles[0];

      if (firstFile && _this.isFileAccepted(firstFile)) {
        onFileDrop(firstFile);
      }
    });

    return _this;
  }

  _createClass(FileDropArea, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('dragenter', this.showDropArea);
      document.addEventListener('dragleave', this.handleDragLeave);
      document.addEventListener('drop', this.hideDropArea);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('dragenter', this.showDropArea);
      document.removeEventListener('dragleave', this.handleDragLeave);
      document.removeEventListener('drop', this.hideDropArea);
    }
  }, {
    key: "isFileAccepted",
    value: function isFileAccepted(file) {
      var accept = this.props.accept;
      return accept.split(',').reduce(function (isAccepted, cur) {
        if (isAccepted) return isAccepted;
        if (file.type === cur) return true;
        var trimmedAccept = cur.trim();

        if (/^\./.test(trimmedAccept) && new RegExp("".concat(trimmedAccept.replace('.', '\\.'), "$")).test(file.name)) {
          return true;
        }

        return false;
      }, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          qa = _this$props2.qa,
          children = _this$props2.children,
          label = _this$props2.label,
          className = _this$props2.className;
      var shouldShowDropArea = this.state.shouldShowDropArea;

      var _FileDropArea$getClas = FileDropArea.getClassName({
        className: className,
        shouldShowDropArea: shouldShowDropArea
      }),
          root = _FileDropArea$getClas.root,
          dropArea = _FileDropArea$getClas.dropArea;

      return /*#__PURE__*/React.createElement("div", {
        "data-qa": qa,
        className: root,
        onDragOver: this.onDragOver,
        onDrop: this.onDrop
      }, children, /*#__PURE__*/React.createElement("div", {
        "data-qa": "".concat(qa, "#dropArea"),
        className: dropArea
      }, /*#__PURE__*/React.createElement("div", {
        className: cx('psw-center')
      }, label)));
    }
  }], [{
    key: "preventDefault",
    value: function preventDefault() {
      externalDragDefaultPreventer.start();
    }
  }, {
    key: "restoreDefault",
    value: function restoreDefault() {
      externalDragDefaultPreventer.stop();
    }
  }]);

  return FileDropArea;
}(PureComponent);

FileDropArea.defaultProps = {
  qa: '',
  className: '',
  label: '',
  accept: '',
  disabled: false,
  onFileDrop: function onFileDrop() {},
  children: null
};
FileDropArea.propTypes = {
  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * Message to show when file is being dragged within the browser window
   */
  label: PropTypes.string,

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * Comma separated string of file extensions or mime types to accept on drop
   */
  accept: PropTypes.string,

  /**
   * Whether or not the drop zone is droppable
   */
  disabled: PropTypes.bool,

  /**
   * event callback to call when a accepted file has been dropped
   */
  onFileDrop: PropTypes.func,

  /**
   * The UI to make a drop area
   */
  children: PropTypes.node
};

FileDropArea.getClassName = function (_ref) {
  var shouldShowDropArea = _ref.shouldShowDropArea,
      className = _ref.className;
  return {
    root: cx('psw-file-drop-area', {
      'psw-file-drop-area--is-hidden': !shouldShowDropArea
    }, className),
    dropArea: cx('psw-drop-area', 'psw-layer', 'psw-p-s', 'psw-border-m')
  };
};

FileDropArea.useClassNames = function (x) {
  FileDropArea.classNames = x;
};

cx = classNamesFor(FileDropArea);
export default FileDropArea;